// Discourages saving site imagery: blocks right-click, drag-to-desktop and
// long-press save on images and photo slots. (No website can fully prevent
// screenshots — this stops casual copying.)
(function () {
  function isImg(e) {
    var p = e.composedPath ? e.composedPath() : [e.target];
    for (var i = 0; i < p.length; i++) {
      var n = p[i]; if (!n || !n.tagName) continue;
      var t = n.tagName;
      if (t === 'IMG' || t === 'IMAGE-SLOT' || t === 'PICTURE' || t === 'CANVAS' || t === 'VIDEO' || t === 'svg') return true;
      if (n.style && n.style.backgroundImage) return true;
    }
    return false;
  }
  document.addEventListener('contextmenu', function (e) { if (isImg(e)) e.preventDefault(); }, true);
  document.addEventListener('dragstart', function (e) { if (isImg(e)) e.preventDefault(); }, true);
  var s = document.createElement('style');
  s.textContent = 'img,image-slot,picture{-webkit-user-drag:none;user-drag:none;-webkit-touch-callout:none;user-select:none;-webkit-user-select:none}';
  document.head.appendChild(s);
})();

// Keep page scrolling smooth over imagery and 3D viewers. 3D viewers stay
// "asleep" (the page scrolls over them) until tapped/clicked, then go back to
// sleep when the pointer leaves or the visitor touches elsewhere.
(function () {
  if (window.__elScrollFix) return; window.__elScrollFix = true;
  var css = document.createElement('style');
  css.textContent = 'image-slot,image-slot img{touch-action:pan-x pan-y pinch-zoom}' +
    'iframe[src*="ijewel"]{pointer-events:none!important;touch-action:pan-x pan-y!important}' +
    'iframe[src*="ijewel"][data-live]{pointer-events:auto!important;touch-action:none!important}' +
    '[data-el3d]{cursor:pointer}';
  document.head.appendChild(css);
  function frameIn(el) {
    for (var n = el, d = 0; n && n !== document.body && d < 4; n = n.parentElement, d++) {
      var f = n.querySelector && n.querySelector('iframe[src*="ijewel"]');
      if (f) return f;
    }
    return null;
  }
  function sleepAll(except) {
    document.querySelectorAll('iframe[src*="ijewel"][data-live]').forEach(function (f) { if (f !== except) f.removeAttribute('data-live'); });
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('a')) return;
    var f = frameIn(e.target);
    sleepAll(f);
    if (f) f.setAttribute('data-live', '');
  }, true);
  document.addEventListener('touchstart', function (e) { if (!frameIn(e.target)) sleepAll(null); }, { passive: true, capture: true });
  document.addEventListener('mouseout', function (e) {
    if (e.target && e.target.tagName === 'IFRAME' && e.target.hasAttribute('data-live')) e.target.removeAttribute('data-live');
  }, true);
})();

// Photo slots: allow page scrolling when a finger rests on a photo.
(function () {
  if (window.__elSlotScroll) return; window.__elSlotScroll = true;
  var RULE = '.frame img,img{touch-action:pan-x pan-y pinch-zoom!important}';
  function fix(el) {
    var r = el.shadowRoot; if (!r || r.__elScroll) return;
    var st = document.createElement('style'); st.textContent = RULE; r.appendChild(st); r.__elScroll = true;
  }
  function scan() { document.querySelectorAll('image-slot').forEach(fix); }
  var q = false;
  function start() {
    scan();
    new MutationObserver(function () { if (q) return; q = true; requestAnimationFrame(function () { q = false; scan(); }); })
      .observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
